<template>
  <table class="involvement-chart-table">
    <tr>
      <td class="involvement-chart-table__date-time-header">
        {{dateTimeTitle}}
      </td>
      <td
        class="involvement-chart-table__views-header"
        v-for="(item) in headers"
        :key="`header${item}`"
      >
        {{item === "u" ? "Неизвестно" : item}}
      </td>
    </tr>

    <tr v-for="(item, key) in viewsDates" :key="key">

        <td class="involvement-chart-table__date-time">
          {{item}}
        </td>

        <td
          v-for="(itemData, itemKey) in viewsData"
          class="involvement-chart-table__value"
          contenteditable="true"
          @keyup.enter="onEnter($event)"
          @blur="updateChartItem($event, key, itemKey)"
          :key="`${key}-${itemKey}`"
        >
          {{itemData[key][1]}}
        </td>

    </tr>
  </table>
</template>

<script>
  import { UPDATE_AUDIT_CHART } from "../../../../../store/actions/audit";

  export default {
    name: "InvolvementTable",
    props: {
      data: {
        type: Object
      },
      chartName: {
        type: String
      }
    },
    computed: {
      dateTimeTitle() {
        return this.data.graph_data["18-25"][0][0].includes("-") ? "Дата" : "Время";
      },
      headers(){
        return Object.keys(this.data.graph_data);
      },
      viewsDates(){
        return this.data.graph_data["18-25"].map(item => item[0]);
      },
      viewsData() {
        return this.data.graph_data;
      }
    },
    methods: {
      onEnter(event) {
        event.target.blur();
      },
      updateChartItem(event, index, key) {
        const value = parseInt(event.target.innerHTML.trim());
        event.target.innerHTML = value;

        this.$store.dispatch(UPDATE_AUDIT_CHART, {
          chart: this.chartName,
          value,
          index,
          key
        })
          .then(() => {
            this.$notify({
              title: this.$t('feed.audit.edit.notify.title'),
              message: this.$t('feed.audit.edit.notify.text'),
              type: 'success',
              duration: 1500,
              showClose: false
            });
          });
      }
    }
  }
</script>

<style>
  .involvement-chart-table {
    width: 100%;
    margin-top: 34px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    border-collapse: collapse;
  }

  .involvement-chart-table td {
    height: 40px;
    padding: 0 0 0 20px;
    border: 2px solid #EBEBEB;
    box-sizing: border-box;
  }

  .involvement-chart-table .involvement-chart-table__date-time-header {
    width: 20%;
    color: #5E6D82;
    border-left: transparent;
  }

  .involvement-chart-table__views-header {
    width: 20%;
    color: #5E6D82;
    cursor: default;
  }

  .involvement-chart-table .involvement-chart-table__views-header {
    border-right: transparent;
  }

  .involvement-chart-table .involvement-chart-table__value {
    border-right: transparent;
  }

  .involvement-chart-table .involvement-chart-table__date-time {
    border-left: transparent;
  }

  .involvement-chart-table__date-time,
  .involvement-chart-table__value {
    color: #5E6D82;
  }

  .involvement-chart-table__value {
    cursor: text;
  }

  .involvement-chart-table__value:hover {
    background-color: #f5f7fa;
  }

  .involvement-chart-table__value:focus {
    outline: none;
    background-color: #f5f7fa;
  }
</style>
